export const RULE_SEARCHES_DEFAULT_LIMIT = 11;

export interface ISearchManagerV2RuleSearchesData {
    ruleId?: string;
    showDisabled?: boolean;
    description?: string | null;
    details?: string | null;
    supplier?: string | null;
    carrier?: string | null;
    offset?: number | null;
    limit?: number | null;
}

export interface ISearchesEditorData {
  ruleSearchesData: ISearchManagerV2RuleSearchesData;
  validation?: any;
}

export class SearchManagerV2RuleSearchesData implements ISearchManagerV2RuleSearchesData {
  ruleId?: string;
  showDisabled?: boolean;
  description?: string | null;
  details?: string | null;
  supplier?: string | null;
  carrier?: string | null;
  offset?: number | null;
  limit?: number | null;

  constructor() {
    this.showDisabled = false;
    this.description = null;
    this.supplier = null;
    this.carrier = null;
    this.details = null;
    this.offset = 0;
    this.limit = RULE_SEARCHES_DEFAULT_LIMIT;
  }
}

export class RuleSearchesData implements ISearchesEditorData {
  ruleSearchesData: ISearchManagerV2RuleSearchesData;
  validation?: any;

  constructor() {
    this.ruleSearchesData = new SearchManagerV2RuleSearchesData();
  }
}
